package br.com.logicalside.proposes.components.sections

import Res
import androidx.compose.runtime.Composable
import br.com.logicalside.proposes.BodyTextStyle
import br.com.logicalside.proposes.Headline3TextStyle
import br.com.logicalside.proposes.components.layouts.InnerContainer
import br.com.logicalside.proposes.toSitePalette
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.dom.Br

@Composable
fun DownloadSection() {
    InnerContainer(DownloadContainerStyle.toModifier().id("download")) {
        Column(Modifier.fillMaxSize(), horizontalAlignment = Alignment.CenterHorizontally) {
            SpanText(
                Res.string.download_title,
                Headline3TextStyle.toModifier().then(DownloadTitleStyle.toModifier())
            )
            SpanText(
                Res.string.download_description,
                BodyTextStyle.toModifier().then(Modifier.padding(top = 0.8.cssRem).textAlign(TextAlign.Center))
            )
            Br()
            Row {
                Link(
                    "https://play.google.com/store/apps/details?id=com.proposes",
                    openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
                ) {
                    Image(
                        "/download_google_play.png",
                        Res.string.download_google_play,
                        DownloadBadgeStyle.toModifier()
                    )
                }
                SpanText("", Modifier.padding(leftRight = 1.2.cssRem))
                Image(
                    "/download_app_store.png",
                    Res.string.download_app_store,
                    DownloadBadgeStyle.toModifier()
                )
            }
        }
    }
}

val DownloadContainerStyle = CssStyle.base {
    Modifier
        .fillMaxWidth()
        .backgroundColor(colorMode.toSitePalette().backgroundVariant)
        .padding(topBottom = 6.cssRem, leftRight = 2.cssRem)
}

val DownloadTitleStyle = CssStyle.base {
    Modifier
        .fontWeight(FontWeight.Bold)
        .textAlign(TextAlign.Center)
        .color(colorMode.toSitePalette().onBackground)
}

val DownloadBadgeStyle = CssStyle {
    base { Modifier.height(2.5.cssRem).display(DisplayStyle.Block) }
    Breakpoint.MD { Modifier.height(4.cssRem) }
}
